var quote = function () {
	$(function () {

		var originPlaceTemp = null;
		var destinationPlaceTemp = null;

		if ($("#calculate-quote-form").length > 0) {

			$("#calculate-quote-form").validate({
				ignore: ":disabled",
				messages: {
					OriginPlaceHomeHero: "Start typing and select from list",
					DestinationPlaceHomeHero: "Start typing and select from list",
					OriginPlace: "Start typing and select from list",
					DestinationPlace: "Start typing and select from list"
				},
				submitHandler: function () {

					var formData = new FormData($(this)[0].currentForm);
					var isMobileSafari = /iP(ad|hone|od).+Version\/[\d\.]+.*Safari/i.test(navigator.userAgent);

					var newTab = isMobileSafari ? window.quoteNewTab : null;

					if (isMobileSafari && newTab) {
						newTab.close();
					}

					newTab = window.open("", "_getquote");

					if (isMobileSafari)
						window.quoteNewTab = newTab;

					$.ajax({
						type: "POST",
						url: "/umbraco/surface/calculatequote/calcquote",
						data: formData,
						contentType: false,
						processData: false,
						success: function (calculateQuoteUrl) {
							if (calculateQuoteUrl.length !== 0) {
								newTab.location = calculateQuoteUrl;
							}
						}
					});

					$("#AddPackages").val("false");

					return false;
				},
				highlight: function (element) {

					if (element.id === "HiddenOriginPlaceHomeHero") {
						$($(this)[0].currentForm).find("#OriginPlaceHomeHero").addClass("error");
					}

					if (element.id === "HiddenDestinationPlaceHomeHero") {
						$($(this)[0].currentForm).find("#DestinationPlaceHomeHero").addClass("error");
					}

					$(element).parent().addClass("error");
					$(element).addClass("error");
				},
				unhighlight: function (element) {

					if (element.id === "OriginPlaceHomeHero" && $($(this)[0].currentForm).find("#HiddenOriginPlaceHomeHero").hasClass("error")) {
					} else if (element.id === "DestinationPlaceHomeHero" && $($(this)[0].currentForm).find("#HiddenDestinationPlaceHomeHero").hasClass("error")) {
					} else {
						$(element).parent().removeClass("error");
						$(element).removeClass("error");
					}
				}
			});
		}

		$(".quote-form-from-place").blur(function () {

			var form = $(this).closest("form");
			if (originPlaceTemp != null) {
				$(form).find("#HiddenOriginPlaceHomeHero").val(originPlaceTemp);
			}
			else if ($(form).find("#HiddenOriginPlaceHomeHero")[0].value !== "") {
			}
			else {
				$(form).find("#HiddenOriginPlaceHomeHero").val(null);
				$(form).find("#OriginPlaceHomeHero").val("");
				$(form).find("#OriginPlaceHomeHero").valid();
			}

			originPlaceTemp = null;
		});

		$(".quote-form-from-place").on('click', function (e) {

			var form = $(this).closest("form");

			$(form).find("#HiddenOriginPlaceHomeHero").val(null);
			$(form).find("#OriginPlaceHomeHero").val("");
			$(form).find("#OriginPlaceHomeHero").valid();

			originPlaceTemp = null;
		});

		$(".quote-form-to-place").blur(function () {

			var form = $(this).closest("form");
			if (destinationPlaceTemp != null) {
				$(form).find("#HiddenDestinationPlaceHomeHero").val(destinationPlaceTemp);
			}
			else if ($(form).find("#HiddenDestinationPlaceHomeHero")[0].value !== "") {
			}
			else {
				$(form).find("#HiddenDestinationPlaceHomeHero").val(null);
				$(form).find("#DestinationPlaceHomeHero").val("");
				$(form).find("#DestinationPlaceHomeHero").valid();
			}

			destinationPlaceTemp = null;
		});

		$(".quote-form-to-place").on('click', function () {

			var form = $(this).closest("form");

			$(form).find("#HiddenDestinationPlaceHomeHero").val(null);
			$(form).find("#DestinationPlaceHomeHero").val("");
			$(form).find("#DestinationPlaceHomeHero").valid();

			destinationPlaceTemp = null;
		});

		$(".quote-form-from-country").change(function () {

			var form = $(this).closest("form");
			var $originPlace = $(form).find("#OriginPlaceHomeHero");
            var $hiddenOriginPlace = $(form).find("#HiddenOriginPlaceHomeHero");

            $originPlace.removeClass('error').next('label.error').remove();
            $hiddenOriginPlace.removeClass('error').next('label.error').remove();

			if (this.value.indexOf("True") !== -1) {

				$originPlace.val(null);
				$originPlace.attr("disabled", false);
				$originPlace.attr("placeholder", "Suburb or Postcode");
                $hiddenOriginPlace.val(null);
                $hiddenOriginPlace.attr("disabled", false);
			} else {
                $originPlace.val(null);
                $originPlace.attr("disabled", true);
                $originPlace.attr("placeholder", "Not Required");
                $hiddenOriginPlace.val(null);
                $hiddenOriginPlace.attr("disabled", true);
			}

		});

		$(".quote-form-to-country").change(function () {

			var form = $(this).closest("form");

			var $destinationPlace = $(form).find("#DestinationPlaceHomeHero");
			var $hiddenDestinationPlace = $(form).find("#HiddenDestinationPlaceHomeHero");


            $destinationPlace.removeClass("error").next("label.error").remove();
            $hiddenDestinationPlace.removeClass("error").next("label.error").remove();

			if (this.value.indexOf("True") !== -1) {
                $destinationPlace.val(null);
				$destinationPlace.attr("disabled", false);
                $destinationPlace.attr("placeholder", "Suburb or Postcode");
                $hiddenDestinationPlace.val(null);
                $hiddenDestinationPlace.attr("disabled", false);
			} else {
                $destinationPlace.val(null);
				$destinationPlace.attr("disabled", true);
                $destinationPlace.attr("placeholder", "Not Required");
                $hiddenDestinationPlace.val(null);
                $hiddenDestinationPlace.attr("disabled", true);
			}
		});

		$(".quote-form-from-place").autocomplete({
			source: function (request, response) {

				var form = $(this.element).closest("form");

				$(form).find("#OriginPlaceHomeHero").addClass("loadinggif");

				$.ajax({
					url: "/umbraco/surface/calculatequote/getcountryplaces",
					type: "GET",
					dataType: "json",
					data: {
						placeId: $(form).find("#OriginCountryHomeHero").val(), filter: request.term
					},
					success: function (data) {

						var results = JSON.parse(data);

						// Populate the array that will be passed to the response callback.
						var autocompleteObjects = [];
						for (var i = 0; i < results.length; i++) {
							var object =
							{
								// Used by jQuery Autocomplete to show
								// autocomplete suggestions as well as
								// the text in yourInputTextBox upon selection.
								// Assign them to a value that you want the user to see.
								value: results[i].name,
								label: results[i].name,

								// Put our own custom id here.
								// If you want to, you can even put the result object.
								id: results[i].placeId
							};

							autocompleteObjects.push(object);
						}

						$(form).find("#OriginPlaceHomeHero").removeClass("loadinggif");

						response(autocompleteObjects);
					}
				});
			},
			minLength: 2,
			select: function (event, ui) {

				var form = $(this).closest("form");

				$(form).find("#HiddenOriginPlaceHomeHero").val(ui.item.id);

				originPlaceTemp = ui.item.id;

				$(form).find('#OriginPlaceHomeHero').removeClass('error').next('label.error').remove();
				$(form).find('#HiddenOriginPlaceHomeHero').removeClass('error').next('label.error').remove();
			},
			open: function (event, ui) {
				$('.ui-autocomplete').off('menufocus hover mouseover mouseenter');
			}
		});

		$(".quote-form-to-place").autocomplete({
			source: function (request, response) {

				var form = $(this.element).closest("form");

				$(form).find("#DestinationPlaceHomeHero").addClass("loadinggif");

				$.ajax({
					url: "/umbraco/surface/calculatequote/getcountryplaces",
					type: "GET",
					dataType: "json",
					data: {
						placeId: $(form).find("#DestinationCountryHomeHero").val(), filter: request.term
					},
					success: function (data) {

						var results = JSON.parse(data);

						// Populate the array that will be passed to the response callback.
						var autocompleteObjects = [];
						for (var i = 0; i < results.length; i++) {
							var object =
							{
								// Used by jQuery Autocomplete to show
								// autocomplete suggestions as well as
								// the text in yourInputTextBox upon selection.
								// Assign them to a value that you want the user to see.
								value: results[i].name,
								label: results[i].name,

								// Put our own custom id here.
								// If you want to, you can even put the result object.
								id: results[i].placeId
							};

							autocompleteObjects.push(object);
						}

						$(form).find("#DestinationPlaceHomeHero").removeClass("loadinggif");

						response(autocompleteObjects);
					}
				});
			},
			minLength: 2,
			select: function (event, ui) {

				var form = $(this).closest("form");

				$(form).find("#HiddenDestinationPlaceHomeHero").val(ui.item.id);

				destinationPlaceTemp = ui.item.id;

				$(form).find("#DestinationPlaceHomeHero").removeClass("error").next("label.error").remove();
				$(form).find("#HiddenDestinationPlaceHomeHero").removeClass("error").next("label.error").remove();
			},
			open: function (event, ui) {
				$('.ui-autocomplete').off('menufocus hover mouseover mouseenter');
			}
		});

		$(document).on("click", ".add_row",
			function (s) {

				var form = $(this).closest("form");
				var itemCount = $(form).find('.dimensions').length + 1;

				var clickedItemId = $(s.currentTarget).parentsUntil(".row").parent().data("item-number");
				var nextItemId = (parseInt(clickedItemId) + 1);

				var items = $(s.currentTarget).parentsUntil(".package-items").parent();

				$(s.currentTarget).parentsUntil(".row").find(".delete_row").show();
				$(s.currentTarget).parentsUntil(".row").find(".add_row").hide();

				$($(items).find("#item-" + nextItemId)[0]).html("<div class=\"col-md-12\">" +
					"<div class=\"form-field dimensions\">" +
					"<input type=\"hidden\" class=\"item-sequence c-calculate-quote-form__input\" name=\"Items[" + (itemCount - 1) + "].Sequence\" data-label=\"Sequence\" id=\"Items[" + (itemCount - 1) + "].Sequence\" value=\"" + (itemCount) + "\" />" +
					"<label class=\"c-calculate-quote-form__label\">Item " + itemCount + "</label>" +
					"<div class=\"c-calculate-quote-form__input-wrapper\">" +
					"    <input type=\"number\" required name=\"Items[" + (itemCount - 1) + "].LengthInCm\" data-label=\"LengthInCm\" id=\"Items[" + (itemCount - 1) + "].LengthInCm\" min=\"1\" step=\"1\" max=\"999\" class=\"c-calculate-quote-form__input\" placeholder=\"L (cm)\">" +
					"</div>" +
					"<div class=\"c-calculate-quote-form__input-wrapper\">" +
					"    <input type=\"number\" required name=\"Items[" + (itemCount - 1) + "].WidthInCm\" data-label=\"WidthInCm\" id=\"Items[" + (itemCount - 1) + "].WidthInCm\" min=\"1\" step=\"1\" max=\"999\" class=\"c-calculate-quote-form__input\" placeholder=\"W (cm)\">" +
					"</div>" +
					"<div class=\"c-calculate-quote-form__input-wrapper\">" +
					"    <input type=\"number\" required name=\"Items[" + (itemCount - 1) + "].HeightInCm\" data-label=\"HeightInCm\" id=\"Items[" + (itemCount - 1) + "].HeightInCm\" min=\"1\" step=\"1\" max=\"999\" class=\"c-calculate-quote-form__input\" placeholder=\"H (cm)\">" +
					"</div>" +
					"<div class=\"c-calculate-quote-form__input-wrapper\">" +
					"    <input type=\"number\" required name=\"Items[" + (itemCount - 1) + "].WeightInKg\" data-label=\"WeightInKg\" id=\"Items[" + (itemCount - 1) + "].WeightInKg\" min=\"0.1\" max=\"999.9\" step=\"0.1\" class=\"c-calculate-quote-form__input\" placeholder=\"Weight (kg)\">" +
					"</div>" +
					"<div class=\"c-calculate-quote-form__input-wrapper\">" +
					"    <input type=\"number\" required name=\"Items[" + (itemCount - 1) + "].ValueInAud\" data-label=\"ValueInAud\" id=\"Items[" + (itemCount - 1) + "].ValueInAud\" min=\"1\" step=\"1\" max=\"99999\" class=\"c-calculate-quote-form__input\" placeholder=\"$ Value (AUD)\">" +
					"</div>" +
					"<div class=\"c-calculate-quote-form-delete-item__input-wrapper\">" +
					"    <a class=\"c-calculate-quote-form__button btn delete_row\" style=\"padding: 7px;\">-</a>" +
					"</div>" +
					"<div class=\"c-calculate-quote-form-add-item__input-wrapper\">" +
					"    <a class=\"c-calculate-quote-form__button btn add_row\" style=\"padding: 7px;\">+</a>" +
					"</div>" +
					"</div>" +
					"</div>");

				$($(items)[0]).append("<div id=\"item-" + (nextItemId + 1) + "\" data-item-number=\"" + (nextItemId + 1) + "\" class=\"row\"></div>");
			}
		);

		$(document).on("click", ".delete_row",
			function (s) {

				var form = $(this).closest("form");

				var clickedItemId = $(s.currentTarget).parentsUntil(".row").parent().data("item-number");

				$(s.currentTarget).parentsUntil(".row").parent().remove();

				if (clickedItemId === $(form).find('.package-items').find('.row').length) {
					$(form).find('.dimensions').last().find('.add_row').show();
				}

				if ($(form).find('.dimensions').length === 1) {
					$(form).find('.dimensions').find(".delete_row").hide();
					$(form).find('.dimensions').find(".add_row").show();
				}

				$(form).find('.package-items').find('.row').each(function (rowIndex) {
					$(this).attr('id', 'item-' + (rowIndex + 1));
					$(this).attr('data-item-number', (rowIndex + 1));
				});


				$(form).find('.dimensions').each(function (rowIndex) {

					$(this).find('.item-sequence').attr('name', 'Items[' + rowIndex + '].Sequence');
					$(this).find('.item-sequence').attr('id', 'Items[' + rowIndex + '].Sequence');
					$(this).find('.item-sequence').attr('value', (rowIndex + 1));

					$(this).find('.c-calculate-quote-form__label').each(function () {
						$(this).text('Item ' + (rowIndex + 1));
					});

					$(this).find('.c-calculate-quote-form__input').each(function () {
						$(this).attr('id', 'Items[' + rowIndex + '].' + $(this).data('label'));
						$(this).attr('name', 'Items[' + rowIndex + '].' + $(this).data('label'));
					});
				});
			}
		);

		$(".ready-to-send, .larger-goods, .unpacked-goods, .excess-baggage").on('click', function () {
			setQuoteTypeParams($(this).data("formid"));
		});

		function setQuoteTypeParams(formId) {

			var validator = $("#calculate-quote-form").validate();
			validator.resetForm();

			switch (formId) {
				case "rts":
					$("#IsExcessBaggage").val("false");
					$("#PackedQuoteYes").prop("checked", true);
					$("#FormId").val(formId);

					$("#contentsCol").removeClass("col-md-9");
					$("#contentsCol").addClass("col-md-5");

					$("#packedCol").show();

					$("#contentsFormField").removeClass("description-long");
					$("#contentsFormField").addClass("description");

					$("#DescriptionQuoteToolbox").prop("required", true);
					$("#SubmitQuoteBtn").html("Get Quote");
					break;

				case "lg":
					$("#IsExcessBaggage").val("false");
					$("#PackedQuoteYes").prop("checked", true);
					$("#FormId").val(formId);

					$("#contentsCol").removeClass("col-md-5");
					$("#contentsCol").addClass("col-md-9");

					$("#packedCol").hide();

					$("#contentsFormField").removeClass("description");
					$("#contentsFormField").addClass("description-long");

					$("#DescriptionQuoteToolbox").prop("required", false);
					$("#SubmitQuoteBtn").html("Submit");
					break;

				case "ug":
					$("#IsExcessBaggage").val("false");
					$("#PackedQuoteNo").prop("checked", true);
					$("#FormId").val(formId);

					$("#contentsCol").removeClass("col-md-5");
					$("#contentsCol").addClass("col-md-9");

					$("#packedCol").hide();

					$("#contentsFormField").removeClass("description");
					$("#contentsFormField").addClass("description-long");

					$("#DescriptionQuoteToolbox").prop("required", false);
					$("#SubmitQuoteBtn").html("Submit");
					break;

				case "eb":
					$("#IsExcessBaggage").val("true");
					$("#PackedQuoteNo").prop("checked", true);
					$("#FormId").val(formId);

					$("#contentsCol").removeClass("col-md-5");
					$("#contentsCol").addClass("col-md-9");

					$("#packedCol").hide();

					$("#contentsFormField").removeClass("description");
					$("#contentsFormField").addClass("description-long");

					$("#DescriptionQuoteToolbox").prop("required", false);
					$("#SubmitQuoteBtn").html("Submit");
					break;
			}
		}
	});
}

module.exports = quote;